export default __webpack_public_path__ + "static/media/IC00060-activity.2a3018da.svg";